<template>
    <div class="grid-12">
        <nav :class="{'col-6':true,'side-bar-wrapper':true,'collapse':sideBarMin}" id="side-bar-wrapper">
            <div class="side-bar">
                <div :class="{'nav-section':true,'nav-section-min':!tabList.themeTab}">
                    <h2 class="nav-section-header" @click="selectTab('theme')">
                        <font-awesome-icon icon="folder" v-if="sideBarMin"></font-awesome-icon>
                        <span v-else>Theme</span>
                    </h2>
                    <div class="nav-section-content collapse-hide">
                        <h3 class="side-bar-header">Theme Name</h3>
                        <input type="text" v-model.lazy="themeName" class="themeNameInput">
                        <h3 class="side-bar-header">Theme Colors</h3>
                        <p class="side-bar-section-description">Double click any color to add/remove it from the theme.</p>
                        <color-display-list :list="$store.state.currentThemeColorList"></color-display-list>
                       <!--  <div v-if="$store.state.currentThemeColorList.length>0">
                            <h3 class="side-bar-header">Download</h3> 
                        </div> -->
                        
                    </div>
                </div>
                <div :class="{'nav-section':true,'nav-section-min':!tabList.colorsTab}">
                    <h2 class="nav-section-header" @click="selectTab('colors')">
                        <font-awesome-icon icon="palette" v-if="sideBarMin"></font-awesome-icon>
                        <span v-else>Colors</span>
                    </h2>
                    <div class="nav-section-content collapse-hide">
                        <ac-button class="select-color-button" @click="showModal=true" block variant="secondary">
                            <span>Select Color</span><font-awesome-icon icon="search"></font-awesome-icon>
                        </ac-button>
                        <h3 class="side-bar-header collapse-hide">Recent</h3>
                        <color-display-list :list="$store.state.currentColorList" class="collapse-hide"></color-display-list>
                        <h3 class="side-bar-header collapse-hide">Harmonies</h3>
                        <dropdown v-model="harmonyMode" :options="harmonyModeList" displace></dropdown>
                        <color-display-list :list="harmonyColorList" class="collapse-hide"></color-display-list>
                    </div>
                </div>
                <div :class="{'nav-section':true,'nav-section-min':!tabList.settingsTab}">
                    <h2 class="nav-section-header" @click="selectTab('settings')">
                        <font-awesome-icon icon="cog" v-if="sideBarMin"></font-awesome-icon>
                        <span v-else>Settings</span>
                    </h2>
                    <div class="nav-section-content collapse-hide">
                        <h3 class="side-bar-header">Display Mode</h3>
                        <dropdown v-model="$store.state.colorDisplayMode" :options="$store.state.colorDisplayModeList" displace></dropdown>
                        <h3 class="side-bar-header">Toggle Mode</h3>
                        <dropdown v-model="$store.state.colorToggleMode" :options="colorToggleModeList" displace></dropdown>
                        <h3 class="side-bar-header">Toggle Settings</h3>
                        <div class="grid-12">
                            <div class="col-10 col-offset-1">  
                                <div v-for="i in colorToggleIncrement.length" :key="i-1">
                                    <h4 class="side-bar-subheader">{{colorToggleConfig.headers[i-1]}} Increment</h4>
                                    <input-number 
                                        v-model="colorToggleIncrement[i-1]"
                                        :max="colorToggleConfig.max[i-1]"
                                        :min="colorToggleConfig.min[i-1]"></input-number>
                                </div> 
                            </div>
                        </div>
                    </div>
                </div>
                <div class="navbar-toggle-wrapper navbar-button" @click="toggleSideBar">
                    <div v-if="sideBarMin" class="navbar-toggle">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                    <div v-else class="navbar-toggle-text">Collapse</div>
                </div>
            </div>
        </nav>
        <div class="col-6" id='content-wrapper'>
            <color-select-modal :color.sync="selectModalColor" :visible.sync="showModal"></color-select-modal>
            <slot></slot>
        </div>
    </div>
</template>
<script type="text/javascript">
    import colorDisplayList from "@/components/colorDisplayList.vue";
    import dropdown from "@/components/dropdown"
    import inputNumber from "@/components/input-number"
    import colorSelectModal from "@/components/color-select-modal";
    export default{
        data(){
            return {
                tabList:{
                    themeTab:false,
                    colorsTab:false,
                    settingsTab:false,
                },
                harmonyMode:"analogous",
                harmonyModeList:[
                    {value:"analogous",text:"Analogous"},
                    {value:"complementary",text:"Complementary"},
                    {value:"monochromatic",text:"Monochromatic"},
                    {value:"split-complementary",text:"Split Complementary"},
                    {value:"tetradic",text:"Tetradic"},
                    {value:"triad",text:"Triad"},
                ],
                showModal:false,
                selectModalColor:new this.$store.state.Color(),
            };
        },
        components:{
            colorDisplayList,
            dropdown,
            inputNumber,
            colorSelectModal
        },
        methods:{
            toggleSideBar(){
                this.sideBarMin=!this.sideBarMin;
            },
            selectTab(tab){
                let tabs = Object.keys(this.tabList);
                for(let i=0;i<tabs.length;i++){
                    if(this.tabList[tabs[i]]!=this.tabList[tab+"Tab"]){
                        this.tabList[tabs[i]]=false
                    }
                }
                this.tabList[tab+"Tab"]=!this.tabList[tab+"Tab"];
            },
            sideBarScreenResize(){
                if(window.innerWidth<768){
                    this.sideBarMin=true;
                }else{
                    this.sideBarMin=false;
                }
            }
        },
        computed:{
            themeName:{
                get:function(){
                    return this.$store.state.currentThemeName;
                },
                set:function(val){
                    this.$store.commit('setThemeName',val);
                }
            },
            currentColor(){
                if(!this.$store.state.currentColor){
                    return (new this.$store.state.Color());
                }else{
                    return this.$store.state.currentColor;
                }
            },
            colorToggleConfigList(){
                return Object.values(this.$store.state.colorToggleConfig);
            },
            colorToggleModeList(){
                return this.colorToggleConfigList.map((model)=>({
                    text:model.title,
                    value:model.name,
                }))
            },
            colorToggleIncrement(){
                return this.$store.state.colorToggleIncrement[this.$store.state.colorToggleMode];
            },
            colorToggleConfig(){
                return this.$store.state.colorToggleConfig[this.$store.state.colorToggleMode]
            },
            // Select Modal Color Components
            selectModalColor1:{
                get:function(){
                    return this.selectModalColor[this.modalColorMode][0]
                },
                set:function(val){
                    let currentModalColor = [...this.selectModalColor[this.modalColorMode]];
                    currentModalColor[0]=val;
                    this.selectModalColor[this.modalColorMode] = currentModalColor;
                }
            },
            selectModalColor2:{
                get:function(){
                    return this.selectModalColor[this.modalColorMode][1]
                },
                set:function(val){
                    let currentModalColor = [...this.selectModalColor[this.modalColorMode]];
                    currentModalColor[1]=val;
                    this.selectModalColor[this.modalColorMode] = currentModalColor;
                }
            },
            selectModalColor3:{
                get:function(){
                    return this.selectModalColor[this.modalColorMode][2]
                },
                set:function(val){
                    let currentModalColor = [...this.selectModalColor[this.modalColorMode]];
                    currentModalColor[2]=val;
                    this.selectModalColor[this.modalColorMode] = currentModalColor;
                }
            },
            sideBarMin:{
                get:function(){
                    let tabOpen = false;
                    let tabs = Object.keys(this.tabList);
                    for(let i=0;i<tabs.length;i++){
                        if(this.tabList[tabs[i]]){
                            tabOpen=true;
                        }
                    }
                    return !tabOpen;
                },
                set:function(val){
                    let tabs = Object.keys(this.tabList);
                    if(!val){
                        let tabOpen = false;
                        for(let i=0;i<tabs.length;i++){
                            if(this.tabList[tabs[i]]){
                                tabOpen=true;
                            }
                        }
                        if(!tabOpen){
                            this.tabList[tabs[0]]=true;
                        }
                    }else{
                        for(let i=0;i<tabs.length;i++){
                            this.tabList[tabs[i]]=false
                        }
                    }
                }
            },
            harmonyColorList(){
                let colorList = [];
                let currentColor = this.$store.state.currentColor;
                switch(this.harmonyMode){
                    case "complementary":{
                        let hslColor = [...currentColor.hsl];
                        colorList.push(new this.$store.state.Color({"color":[hslColor[0]+180,hslColor[1],hslColor[2]],"type":"hsl"}))
                        break;
                    }
                    case "monochromatic":{
                        let hslColor = [...currentColor.hsl];
                        let colorCount=10;
                        let stopSize = 5;
                        let stopsAbove = Math.min(Math.floor((100-hslColor[2])/stopSize),parseInt(colorCount/2));
                        let stopsBelow = Math.min(Math.floor((hslColor[2]-0)/stopSize),parseInt(colorCount/2));
                        for(let i = hslColor[2]-stopsBelow*stopSize;i<hslColor[2]+stopsAbove*stopSize;i+=stopSize){
                            colorList.push(new this.$store.state.Color({"color":[hslColor[0],hslColor[1],i],"type":"hsl"}))
                        }
                        break;
                    }
                    case "analogous":{
                        let hslColor = [...currentColor.hsl];
                        colorList.push(new this.$store.state.Color({"color":[hslColor[0]-30, hslColor[1],hslColor[2]],"type":"hsl"}));
                        colorList.push(new this.$store.state.Color({"color":hslColor,"type":"hsl"}));
                        colorList.push(new this.$store.state.Color({"color":[hslColor[0]+30, hslColor[1],hslColor[2]],"type":"hsl"}));
                        break;
                    }
                    case "split-complementary":{
                        let hslColor = [...currentColor.hsl];
                        let complementaryColor = [hslColor[0]+180,hslColor[1],hslColor[2]];
                        colorList.push(new this.$store.state.Color({"color":hslColor,"type":"hsl"}));
                        colorList.push(new this.$store.state.Color({"color":[complementaryColor[0]-30, complementaryColor[1],complementaryColor[2]],"type":"hsl"}));
                        colorList.push(new this.$store.state.Color({"color":[complementaryColor[0]+30, complementaryColor[1],complementaryColor[2]],"type":"hsl"}));
                        break;
                    }
                    case "tetradic":{
                        let hslColor = [...currentColor.hsl];
                        colorList.push(new this.$store.state.Color({"color":hslColor,"type":"hsl"}));
                        colorList.push(new this.$store.state.Color({"color":[hslColor[0]+60, hslColor[1],hslColor[2]],"type":"hsl"}));
                        colorList.push(new this.$store.state.Color({"color":[hslColor[0]+180, hslColor[1],hslColor[2]],"type":"hsl"}));
                        colorList.push(new this.$store.state.Color({"color":[hslColor[0]+240, hslColor[1],hslColor[2]],"type":"hsl"}));
                        break;
                    }
                    case "triad":{
                        let hslColor = [...currentColor.hsl];
                        colorList.push(new this.$store.state.Color({"color":[hslColor[0]-120, hslColor[1],hslColor[2]],"type":"hsl"}));
                        colorList.push(new this.$store.state.Color({"color":hslColor,"type":"hsl"}));
                        colorList.push(new this.$store.state.Color({"color":[hslColor[0]+120, hslColor[1],hslColor[2]],"type":"hsl"}));
                        break;
                    }
                }
                return colorList;
            }
        },
        mounted(){
            this.sideBarMin=false;
            window.addEventListener("resize", this.sideBarScreenResize);
            this.sideBarScreenResize();
            this.selectModalColor = new this.$store.state.Color({"color":[...this.currentColor.rgb]});
        },
        watch:{
            selectModalColor:{
                deep:true,
                handler(){
                    this.$store.commit('setCurrentColor',new this.$store.state.Color({"color":this.selectModalColor.xyz,"type":"xyz"}));
                }
            }
        }
    }
</script>
<style type="text/css">
    .button{
        font-size: 16px;
    }
    #side-bar-wrapper{
        background-color: #f6f6f6;
        position: fixed;
        box-shadow: 5px 0 5px rgba(0,0,0,0.5);
        z-index: 10000000000;
        left: 0;
        top: 0;
        height: 100%;
        width: 300px;
        max-width: 90vw;
    }
    #side-bar-wrapper.collapse{
        width: 50px;
    }
    .collapse .collapse-hide{
        display: none;
    }
    .side-bar{
        width: 100%;
        height: 100%;
        position: relative;
    }
    #content-wrapper{
        width: calc(100vw - 50px);
        box-sizing: border-box;
        position: relative;
        left: 50px
    }
    @media screen and (min-width: 768px){
        #content-wrapper{
            width: calc(100vw - 300px);
            box-sizing: border-box;
            position: relative;
            left: 300px
        }
        .collapse + #content-wrapper{
            width: calc(100vw - 50px);
            box-sizing: border-box;
            position: relative;
            left: 50px
        }
    }
    .navbar-button,
    .collapse .nav-section-header{
        transition: background-color 0.15s ease-in-out;
        background-color: #FFF;
        border-top: solid 1px #888;
        border-bottom: solid 1px #888;
    }
    .collapse .nav-section + .nav-section .nav-section-header{
        border-top: none;
    }
    .navbar-button:hover,
    .collapse .nav-section-header:hover{
        background-color: rgba(0,0,0,0.1);
    }
    .navbar-toggle-wrapper{
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        cursor: pointer;
        padding: 10px 0;
    }
    .navbar-toggle-text{
        padding: 8px 0;
        text-align: center;
        text-transform: uppercase;
        letter-spacing: 1px;
    }
    .navbar-toggle span{
        display: block;
        height: 5px;
        margin: 5px 10%;
        width: 80%;
        background-color: #555;
    }
    .nav-section{
        position: absolute;
        left:0;
        width: 100%;
    }
    .nav-section:nth-child(1),
    .nav-section:nth-child(1).nav-section-min
    {
        top: 0;
        bottom: calc(100vh - 69px);
        z-index: 100000;
    }
    .nav-section:nth-child(2){
        top: 68px;
        z-index: 99999;
    }
    .nav-section:nth-child(2).nav-section-min{
        bottom: 126px;
    }
    .nav-section-min + .nav-section:nth-child(2).nav-section-min{
        bottom: calc(100vh - 69px * 2);
    }
    .nav-section:nth-child(3){
        top: 136px;
        z-index: 99998;
    }
    .nav-section:nth-child(3).nav-section-min{
        bottom: 57px;
    }
    .collapse .nav-section-min.nav-section,
    .collapse .nav-section-min.nav-section + .nav-section-min.nav-section
    {
        position: relative;
        top: unset;
        bottom: unset;
    }
    .nav-section-header{
        text-transform: uppercase;
        left: 0;
        width: calc(100% + 30px);
        position: absolute;
        z-index: 10000;
        text-align: center;
        justify-content: center;
        padding: 4% 0;
        background-color: #FFF;
        font-size: 2.3em;
        cursor: pointer;
    }
    .nav-section-min .nav-section-header{
        bottom: 0;
    }
    .collapse .nav-section-header{
        position: relative;
        width: 100%;
        padding: 20% 0;
    }
    .collapse .nav-section-header::after,
    .collapse .nav-section-header::before
    {
        content: none;
    }
    .nav-section-min .nav-section-header::before{
        box-shadow: 0 -5px 20px rgba(0,0,0,0.2);;
        border-bottom: solid 1px #888;
    }
    .nav-section-header::before{
        content: "";
        box-shadow: 0 5px 20px rgba(0,0,0,0.3);
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 1000000;
    }

    .nav-section-header::after{
        content: "";
        position: absolute;
        right: 0;
        bottom: -20px;
        border-left: solid 30px #ccc;
        border-bottom: solid 20px transparent;
        z-index: ;
    }
    .nav-section-min .nav-section-header::after{
        border-left: solid 30px #ccc;
        border-bottom: none;
        border-top: solid 20px transparent;
        top: -20px;
        bottom: unset;

    }
    .nav-section-content{
        position: relative;
        top: 4.3em;
        box-sizing: border-box;
        width: 100%;
        max-height: calc(100vh - ( 3 * 68px) - 58px);
        overflow-y: scroll;
    }
    .nav-section-min .nav-section-content{
        display: none;
    }
    .side-bar .themeNameInput{
        width: 100%;
        border-radius: 0;
        border-style: solid;
        border-width: 3.5px 3px 3px 3px;
        border-color: transparent;
        transition: border-color 0.15s ease-in-out;
        text-align: center;
    }
    .side-bar .themeNameInput:hover{
        border-color: #c3c3c3;
    }
    .side-bar .themeNameInput:focus{
        border-color: #3f53cc;
    }
    .side-bar-section-description{
        margin: 0;
        padding: 10px;
        font-size: 0.9em;
        text-align: center;
        color: #333;
        position: relative;
        z-index: 50;
        box-shadow: 0 5px 20px rgba(0,0,0,0.2);
    }
    .side-bar-header{
        text-transform: uppercase;
        box-shadow: 0 5px 20px rgba(0,0,0,0.2);
        position: relative;
        z-index: 100;
        text-align: center;
        justify-content: center;
        padding: 2% 0;
        font-size: 1.5em;
        font-weight: 400;
        background-color: #222;
        color: #FFF;
    }
    .side-bar-subheader{
        font-weight: 400;
        letter-spacing: 1px;
        font-size: 1.25em;
        padding: 2% 0;
        justify-content: center;
    }
    .side-bar .color-square-wrapper{
        display: flex;
        justify-content: center;
    }

    .select-color-button.button{
        background-color: #333;
        border-radius: 0;
        color: #FFF;
        font-size: 16px;
        font-weight: 400;
        text-transform: uppercase;
        -webkit-text-fill-color:#FFF;
    }
    .select-color-button span,
    .select-color-button svg
    {
        -webkit-text-fill-color:#FFF;
        color:#FFF;
    }
    .select-color-button.button.button--secondary--solid:hover{
        background-color: #555;
        columns: #FFF;
    }
    .select-color-button span{
        margin-right: 5%;
        font-size: 1.1em;
    }
</style>